import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Button, FormControl, TextField } from "@mui/material/";
import actions from "../../../Store/actions";
import { strings } from "../../i18n";
import styles from "./styles";
import { logToSentry } from "../../../config/Sentry";

const formatRefs = (branch: number, refs: string) => {
    const next = [];
    refs.split(/[\n;]/).forEach((ref) => {
        if (ref) {
            next.push({ branch, name: ref });
        }
    });
    return next;
};

type Props = {
    onSubmit: Function
};
/**
 * Branch Form Component
 */
export default ({ onSubmit }: Props) => {
    const dispatch = useDispatch();
    const [refs, setRefs] = useState("");
    const [err, setError] = useState(null);
    const { data, item } = useSelector((state) => state.branches);

    const handleChange = (name: string) => (event: Event) => {
        const { value } = event.target;
        dispatch(actions.branches.create.itemUpdate({ [name]: value }));
    };

    const onRefsBlur = () => {
        const next = formatRefs(item.id, refs);
        dispatch(actions.branches.create.itemUpdate({ branchRef: next }));
    };

    const onRefsChange = (event: Event) => {
        const { value } = event.target;
        setRefs(value);
    };

    const onSave = async () => {
        const isUpdate = Boolean(item.id);
        try {
            if (isUpdate) {
                await dispatch(actions.branches.create.patchRequest(item));
            } else {
                await dispatch(actions.branches.create.postRequest([item]));
            }
            await dispatch(actions.branches.create.getRequest());
            const message = strings(
                isUpdate ? "updatedSuccessfully" : "createdSuccessfully"
            );
            dispatch(actions.toast.create.success(message));
            onSubmit();
        } catch (error) {
            logToSentry("On branch save:", { error });
            console.error(error);
        }
    };

    useEffect(() => {
        setRefs((item.branchRef || []).map((ref) => ref.name).join("\n"));
    }, [item]);

    return (
        <form>
            <FormControl fullWidth margin="normal">
                <TextField
                    variant="standard"
                    label={strings("name")}
                    onChange={handleChange("name")}
                    value={item.name}
                    error={err ? true : false}
                    helperText={err ? err : null}
                />
            </FormControl>
            <FormControl fullWidth margin="normal">
                <TextField
                    variant="standard"
                    label={strings("refs")}
                    multiline
                    onBlur={onRefsBlur}
                    onChange={onRefsChange}
                    minRows={5}
                    maxRows={5}
                    value={refs}
                />
            </FormControl>
            <FormControl fullWidth margin="normal">
                <Button
                    variant="contained"
                    size="medium"
                    disabled={!item.name || !refs.trim()}
                    onClick={onSave}
                    sx={styles.primaryButton}
                >
                    {strings("save")}
                </Button>
            </FormControl>
        </form>
    );
};
